import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-37",
  "use": "icon-icon-nav-37-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-37\"><path d=\"M289.664 229.056H168.448A40.512 40.512 0 0 0 128 269.44v484.992c0 22.272 18.176 40.448 40.448 40.448h121.216a40.512 40.512 0 0 0 40.448-40.448V269.504a40.512 40.512 0 0 0-40.448-40.448z m565.888 0h-121.216a40.512 40.512 0 0 0-40.448 40.448v484.992c0 22.272 18.176 40.448 40.448 40.448h121.216A40.512 40.512 0 0 0 896 754.56V269.504a40.512 40.512 0 0 0-40.448-40.448z m-282.88 0H451.328a40.512 40.512 0 0 0-40.448 40.448v484.992c0 22.272 18.176 40.448 40.448 40.448h121.216a40.512 40.512 0 0 0 40.448-40.448V269.504a40.512 40.512 0 0 0-40.448-40.448z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-37.svg
// module id = UkRV
// module chunks = 3